const setProfile = (state, action) => action.profile || state;
export default setProfile;
